export default __webpack_public_path__ + "static/media/pr_c_08.c547a5ef.jpg";